import { useState } from 'react';
import { Button, Form, Input, Typography } from 'antd';
import { useConnection } from '../utils/connection';
import FloatingElement from '../components/layout/FloatingElement';
import styled from 'styled-components';
import { useWallet } from '@solana/wallet-adapter-react';
import { createFaucet } from '../utils/faucet';
import { getMint } from '@solana/spl-token';
import { PublicKey } from '@solana/web3.js';
import { BN } from 'bn.js';

const { Text, Title } = Typography;

const Wrapper = styled.div`
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 24px;
  margin-bottom: 24px;
`;

type ListedMarketState = PublicKey | null;

export default function AirdropPage() {
  const connection = useConnection();
  const walletContext = useWallet();
  const { wallet, connected } = walletContext;

  const [submitting, setSubmitting] = useState(false);
  const [mintAddress, setMintAddress] = useState('');
  const [maxAirdrop, setMaxAirdrop] = useState('1000');
  const [adminAddress, setAdminAddress] = useState(
    wallet?.adapter.publicKey!.toString()!,
  );
  const [faucetAddress, setFaucetAddress] = useState('');

  async function handleCreateFaucet() {
    const maxAirdropNum = maxAirdrop as any as number;
    if (mintAddress.length < 1 || maxAirdropNum < 1 || !wallet) return;
    setSubmitting(true);
    const mintInfo = await getMint(connection, new PublicKey(mintAddress));
    setFaucetAddress(
      await createFaucet(
        connection,
        wallet,
        mintAddress,
        new BN(Math.round(maxAirdropNum * Math.pow(10, mintInfo.decimals)), 10),
        adminAddress.length > 1 ? adminAddress : undefined,
      ),
    );
    setSubmitting(false);
  }

  return (
    <Wrapper>
      <FloatingElement>
        <Title level={4}>Create Faucet</Title>
        <Form onFinish={handleCreateFaucet}>
          <Form.Item label="Mint Address" initialValue={mintAddress}>
            <Input
              value={mintAddress}
              onChange={(e) => setMintAddress(e.target.value.trim())}
            />
          </Form.Item>

          <Form.Item label="Max Airdrop Amount" initialValue={maxAirdrop}>
            <Input
              value={maxAirdrop}
              onChange={(e) => setMaxAirdrop(e.target.value.trim())}
              type="number"
              min="0"
              step="any"
            />
          </Form.Item>

          {/* <Form.Item label="Admin Address" initialValue={adminAddress}>
            <Input
              value={adminAddress}
              onChange={(e) => setAdminAddress(e.target.value.trim())}
            />
          </Form.Item> */}

          <Form.Item label=" " colon={false}>
            <Button type="primary" htmlType="submit" loading={submitting}>
              {connected ? 'Create' : 'Not connected to wallet'}
            </Button>
          </Form.Item>
        </Form>
      </FloatingElement>

      {!!faucetAddress ? (
        <FloatingElement>
          <Text>Faucet address: {faucetAddress}</Text>
        </FloatingElement>
      ) : (
        <></>
      )}
    </Wrapper>
  );
}
